<template>
  <div>
    <b-skeleton-wrapper>
      <template #loading>
        <b-skeleton
          type="button"
          width="100%"
          class="mb-75"
        />
      </template>
      <div>
        <feather-icon
          class="mr-25"
          icon="CheckCircleIcon"
        />
        <span class="ml-25">
          En caso de dudas con el proceso por favor contacte a Control Escolar por correo a la clave especialidades@indetec.gob.mx o vía telefónica al 33 3669 5550 al 59 ext 309 y 311.
          <br>Los horarios de atención del INDETEC es de lunes a viernes de 8 a 16 hrs. (CST)</span>

      </div>
    </b-skeleton-wrapper>
  </div>
</template>
<script>
import {
  BSkeletonWrapper,
  BSkeleton,
} from 'bootstrap-vue'

export default {
  components: {
    BSkeletonWrapper,
    BSkeleton,
  },
  props: {
    tipo: {
      type: [Number, null],
      default: null,
    },
  },
  setup() {
    return {
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
